module.exports = __webpack_public_path__ + "img/108.58a072a9.jpg";